import { useEffect, useState } from "react";
import { getLoggedinUser } from "../../helpers/api_helper";

const useProfile = () => {
  const userProfileSession = getLoggedinUser();
  const tokenSession = userProfileSession && userProfileSession["token"];

  const [loading, setLoading] = useState(false);
  const [userProfile, setUserProfile] = useState<any>(userProfileSession);
  const [token, setToken] = useState<any>(tokenSession);

  useEffect(() => {
    const userProfileSession = getLoggedinUser();
    const tokenSession = userProfileSession && userProfileSession["token"];
    
    setUserProfile(userProfileSession ? userProfileSession : null);
    setToken(tokenSession ? tokenSession : null);
    setLoading(false);
  }, []);

  return { userProfile, loading, token };
};

export { useProfile };
